/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.16",
  "buildId": "20260804-1529-de1cd63",
  "builtAt": "2026-08-04T09:59:56.408Z"
});
